<div
  class="eva-avatar"
  [class.eva-avatar--xsmall]="size === 'xsmall'"
  [class.eva-avatar--small]="size === 'small'"
  [class.eva-avatar--medium]="size === 'medium'"
  [class.eva-avatar--large]="size === 'large'"
  [class.eva-avatar--xlarge]="size === 'xlarge'"
  [class.eva-avatar--circle]="shape === 'circle'"
  [class.eva-avatar--square]="shape === 'square'"
  [style.background-color]="effectiveDisplayMode !== 'image' ? backgroundColor : null"
>
  <!-- Image -->
  <img
    *ngIf="effectiveDisplayMode === 'image'"
    [src]="src"
    [alt]="name || 'Avatar'"
    class="eva-avatar__image"
    (error)="onImageError()"
  />

  <!-- Initials -->
  <span *ngIf="effectiveDisplayMode === 'initials'" class="eva-avatar__initials">
    {{ initials }}
  </span>

  <!-- Icon fallback -->
  @if (effectiveDisplayMode === "icon") {
    @if (isNgIconName(icon)) {
      <ng-icon [name]="icon" class="eva-avatar__icon" />
    } @else if (icon) {
      <i [class]="icon" class="eva-avatar__icon"></i>
    } @else {
      <ng-icon name="heroUser" class="eva-avatar__icon" />
    }
  }

  <!-- Badge -->
  <span
    *ngIf="badge"
    class="eva-avatar__badge"
    [class.eva-avatar__badge--primary]="badgeSeverity === 'primary'"
    [class.eva-avatar__badge--success]="badgeSeverity === 'success'"
    [class.eva-avatar__badge--warning]="badgeSeverity === 'warning'"
    [class.eva-avatar__badge--danger]="badgeSeverity === 'danger'"
  >
    {{ badge }}
  </span>

  <!-- Status indicator -->
  <span
    *ngIf="status"
    class="eva-avatar__status"
    [class.eva-avatar__status--online]="status === 'online'"
    [class.eva-avatar__status--offline]="status === 'offline'"
    [class.eva-avatar__status--busy]="status === 'busy'"
    [class.eva-avatar__status--away]="status === 'away'"
  ></span>
</div>
